.root {
  max-width: 100%;
  overflow: auto;
  padding: 1rem;
  border: 1px solid var(--color-code-border);
  border-radius: var(--radius-lg);
  background: var(--color-code-background);
  color: var(--color-code-foreground);
  color-scheme: dark;
  scrollbar-color: var(--color-code-muted) var(--color-code-background);
  font-family: var(--font-mono);
  font-size: 0.8125rem;
  font-variant-ligatures: none;
  line-height: 1.6;
  tab-size: 2;
}

.root[data-density="compact"] {
  padding: 0.75rem;
  border-radius: var(--radius-md);
  font-size: 0.75rem;
}

.root[data-wrap="true"] {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.root code {
  color: inherit;
  font: inherit;
}

.key,
.type {
  color: var(--color-code-type);
}

.string {
  color: var(--color-code-string);
}

.number {
  color: var(--color-code-number);
}

.constant {
  color: var(--color-code-constant);
}
